module.exports = __webpack_public_path__ + "static/media/loader.eba0b0c5.svg";